import Presenter from 'microcosm/addons/presenter'
import Historical from '../../components/factors/historical'

import {
  currentAggregates,
  focusedAggregate,
  highlight,
  byRegion
} from '../../queries'

class FactorsHistoricalPresenter extends Presenter {
  view = Historical

  setup(repo) {
    repo.index('series', 'factors,ui.focused,ui.region', byRegion('factors'))
  }

  getModel({ location }) {
    const { query } = location

    return {
      query: query,
      region: state => state.ui.region,
      series: this.repo.memo('series', currentAggregates(query)),
      factors: this.repo.memo('series', highlight(query)),
      aggregate: this.repo.memo('series', highlight(query), focusedAggregate)
    }
  }
}

export default FactorsHistoricalPresenter



// WEBPACK FOOTER //
// ./src/presenters/factors/historical.js